import { render, staticRenderFns } from "./index.vue?vue&type=template&id=244ea635&scoped=true&"
import script from "./scripts/index.js?vue&type=script&lang=js&"
export * from "./scripts/index.js?vue&type=script&lang=js&"
import style0 from "./scoped.css?vue&type=style&index=0&id=244ea635&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ea635",
  null
  
)

export default component.exports